import { render, staticRenderFns } from "./BaseIconButtonMenuBook.vue?vue&type=template&id=41e49263&scoped=true&"
import script from "./BaseIconButtonMenuBook.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonMenuBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e49263",
  null
  
)

export default component.exports